export default "__VITE_ASSET__b831fc6e__"